import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';
import { HelpdeskDtoKeyEnum } from '@zaoblako/shared/modules/helpdesk/enum/helpdesk-dto-key.enum';
import { HelpdeskTaskStatusEnum } from '@zaoblako/shared/modules/helpdesk/enum/helpdesk.task.status.enum';

import * as yup from 'yup';

export interface HelpdeskTaskStatusFindInterface {
  id: number;
  name: string;
  order: number;
  color: string;
  code: HelpdeskTaskStatusEnum;
}


export const HelpdeskTaskStatusFindDto = SerdeDtoClass.create<HelpdeskTaskStatusFindInterface>(
  HelpdeskDtoKeyEnum.HELPDESK_TASK_STATUS_FIND_DTO,
  {
    id: {
      label: 'Номер',
      serializer: yup.number(),
    },
    name: {
      label: 'Имя',
      sortable: true,
      serializer: yup.string(),
    },
    order: {
      sortable: true,
      label: 'Порядок',
      serializer: yup.number(),
    },
    color: {
      optional: true,
      label: 'Цвет',
      serializer: yup.string(),
    },
    code: {
      optional: true,
      label: 'Код',
      serializer: yup
        .string()
        .oneOf(Object.values(HelpdeskTaskStatusEnum)),
    },
  },
);